/**
 * Компонент Toast уведомлений
 */

import { useEffect, useState } from 'react';
import styles from './Toast.module.css';

export type ToastType = 'error' | 'success' | 'info';

interface ToastProps {
  message: string;
  type?: ToastType;
  duration?: number;
  onClose: () => void;
}

export function Toast({ message, type = 'info', duration = 3000, onClose }: ToastProps) {
  const [isHiding, setIsHiding] = useState(false);

  useEffect(() => {
    const hideTimer = setTimeout(() => {
      setIsHiding(true);
    }, duration);

    const removeTimer = setTimeout(() => {
      onClose();
    }, duration + 300);

    return () => {
      clearTimeout(hideTimer);
      clearTimeout(removeTimer);
    };
  }, [duration, onClose]);

  return (
    <div className={`${styles.toast} ${styles[type]} ${isHiding ? styles.hiding : ''}`} role="alert" aria-live="assertive">
      {message}
    </div>
  );
}

